import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryEngagementsPage } from "@/strapiQuery/engagements";
import { CommitmentsPageContent } from "@/components/pages/Commitments/Commitments";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const engagementsPageContentPromise = getStrapiEntity<CommitmentsPageContent>(
    "engagement",
    queryEngagementsPage
  );

  const [layout, commitmentsPageContent] = await Promise.all([
    layoutPromise,
    engagementsPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...commitmentsPageContent,
      intlMessages,
      defaultCanonicalRoute: routes.engagements,
    },
    revalidate: 10,
  };
};

export { Commitments as default } from "@/components/pages/Commitments/Commitments";
